import Route from '@ember/routing/route';

class OutRoute extends Route {
  /**
   * @inheritDoc
   */
  setupController() {
    super.setupController(...arguments);

    this.controller.navigateToOutUrl();
  }
}

export default OutRoute;

